import {
  actions,
  getQuestionsAsDataTableAsync,
  getQuestionsByQuizIdAsync,
  createNewQuestionAsync,
  editQuestionAsync,
  deleteQuestionAsync,
  changeQuestionPublishStateAsync,
  orderQuestionsAsync,
} from './slices';

export const QuestionsActions = {
  ...actions,
  getQuestionsAsDataTableAsync,
  getQuestionsByQuizIdAsync,
  createNewQuestionAsync,
  editQuestionAsync,
  deleteQuestionAsync,
  changeQuestionPublishStateAsync,
  orderQuestionsAsync,
};
